import { useParams, useLocation } from "react-router-dom";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";

export default function useLangRoute() {
  const { lang } = useParams();
  const location = useLocation();
  const active = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const other = active === "ar" ? "en" : "ar";
  // subpath after /:lang
  const parts = location.pathname.split("/").filter(Boolean);
  const rest = parts.slice(1).join("/");
  const base = `/${active}`;
  const path = (p) => {
    if (!p || p === "/") return base;
    return `${base}/${p.replace(/^\//, "")}`;
  };
  const otherPath = rest ? `/${other}/${rest}` : `/${other}`;
  return { lang: active, other, otherPath, path };
}
